// 新建任务字段太多，每个任务都写一遍，没必要，引入到需要使用的地方进行深拷贝就行
export const createTaskParams = {
    'alarmConfig': {
        'enable': true,
        'notifyConfig': {
            'enabledAlarmLevels': [''],
            'enabledTimeAlarmLevels': [''],
            'frequency': {
                'unit': '',
                'value': 0
            },
            'url': ''
        },
        'thresholdConfigs': [
            {
                'effectiveTimes': [
                    {
                        'end': '',
                        'start': ''
                    }
                ],
                'effectivePeriod': 'PERMANENT',
                'dayOfWeeks': [],
                'effectiveDates': {
                    'end': '',
                    'start': ''
                },
                'levelConfig': {
                    'critical': 0,
                    'major': 0,
                    'minor': 0,
                    'unit': ''
                },
                'threshold': {
                    'type': '',
                    'unit': '',
                    'value': 0
                }
            }
        ]
    },
    'bondTaskId': '',
    'deviceTaskConfigs': [
        {
            'roiData': '',
            // 'congregateConfig': null,
            'crosslineStatisticConfig': {
                crossLine: [{}],
                directions: [{}],
            },
            'regionStatisticConfig': {
                roiMappings: [{ 'rawRoi': {},
                        'twinRoi': {} }]
            },
            'intrusionConfig': {
                roiMappings: [{ 'rawRoi': {},
                        'twinRoi': {} }]
            },
            // 'crowdDensityConfig': null,
            // 'crowdStrandConfig': null,
            'deviceId': '',
            // 'deviceName': '',
            // 'faceConfig': {
            //   'libraryIds': [],
            //   'matchThreshold': 0
            // },
            'incidentType': 'INCIDENT_AREA',
            // 'intrusionConfig': null,
            'labelPersons': [{}],
            'queueAreaConfig': {},
            'zoneId': ''
            // 'queueConfig': null,
        },
        // 'retrogradeConfig': null,
        // 'roiData': '',
        // 'socialDistanceConfig': null
    ],
    'externalBizFrom': '',
    'remark': '',
    'taskName': '',
    'taskStatus': '',
    'taskId': '',
    'taskType': '',
    // 'zoneId': 1
};
